import { FC, ReactNode, useEffect } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "features/auth/useAuth";
import DocumentTitle from "components/DocumentTitle";
import { useDispatch, useSelector } from "app/store";
import { ScrollToTop } from "./ScrollToTop";
import FailureCreateModal from "features/failures/create/FailureCreateModal";

export type PrivateRouteProps = {
  claims?: string[];
  title?: string;
  children?: ReactNode;
};

export const PrivateRoute: FC<PrivateRouteProps> = ({
  title,
  claims,
  children,
}) => {
  const { userIsLoggedIn, hasClaim, userInfo } = useAuth();
  const dispatch = useDispatch();

  const { isVisible: isFailureCreateModalVisible } = useSelector(
    (state) => state.failureCreate
  );

  const renderLoggedInContent = () =>
    hasClaim(claims) ? (
      <ScrollToTop>
        <DocumentTitle title={title} />
        {children}

        {userInfo && (
          <FailureCreateModal
            visible={isFailureCreateModalVisible}
            onCancel={() => dispatch.failureCreate.setIsVisible(false)}
          />
        )}
      </ScrollToTop>
    ) : (
      <Navigate to={{ pathname: "/" }} replace />
    );

  const renderNotLoggedInContent = () => (
    <Navigate to={{ pathname: "/login" }} replace />
  );

  useEffect(() => {
    dispatch.common.setCurrentPageTitle(title);
  }, [dispatch.common, title]);

  return userIsLoggedIn ? renderLoggedInContent() : renderNotLoggedInContent();
};
